import axios from 'axios';
import { getAuthHeaders, createAction, toQueryString } from '../../utils/utils';

import { updateNotification } from './notifications.actions';

export const LOAD_PROFILE = '[Profile] LOAD_PROFILE';
export function loadProfile() {
  return { type: LOAD_PROFILE };
}

export const LOAD_PROFILE_SUCCESS = '[Profile] LOAD_PROFILE_SUCCESS';
export function loadProfileSuccess(data) {
  return { type: LOAD_PROFILE_SUCCESS, data };
}

export const LOAD_PROFILE_FAILED = '[Profile] LOAD_PROFILE_FAILED';
export function loadProfileFailed(error) {
  return { type: LOAD_PROFILE_FAILED, error };
}

export const UPDATE_ONE = '[Profile] UPDATE_ONE';
export function updateOne(data) {
  return { type: UPDATE_ONE, data };
}

export const UPDATE_ONE_FAILED = '[Profile] UPDATE_ONE_FAILED';
export function updateOneFailed(error, PerfilId) {
  return { type: UPDATE_ONE_FAILED, error, PerfilId };
}

export const UPDATE_ONE_SUCCESS = '[Profile] UPDATE_ONE_SUCCESS';
export function updateOneSucess(data) {
  return { type: UPDATE_ONE_SUCCESS, data };
}

export const CREATE = '[Profile] CREATE';
export function create(data) {
  return { type: CREATE, data };
}

export const CREATE_SUCCESS = '[Profile] CREATE_SUCCESS';
export function createSuccess(data) {
  return { type: CREATE_SUCCESS, data };
}
export const CREATE_SUCCESS_MESSAGE = '[Profile] CREATE_SUCCESS_MESSAGE';
export function createSuccessMessage(data) {
  return { type: CREATE_SUCCESS_MESSAGE, data };
}

export const CREATE_FAILED = '[Profile] CREATE_FAILED';
export function createFailed(error) {
  return { type: CREATE_FAILED, error };
}

export const DELETE = '[Profile] DELETE';
export function deleteProfile(data) {
  return { type: DELETE, data };
}

export const DELETE_SUCCESS = '[Profile] DELETE_SUCCESS';
export function deleteSuccess(data) {
  return { type: DELETE_SUCCESS, data };
}

export const DELETE_FAILED = '[Profile] DELETE_FAILED';
export function deleteFailed(error) {
  return { type: DELETE_FAILED, error };
}

export function fetchAll(filters = {}) {
  return async function (dispatch, getState) {
    dispatch(loadProfile());

    try {
      let url = `${window.config.API_URL_USER}profiles`;

      if (Object.keys(filters).length) {
        url = `${url}?${toQueryString(filters)}`;
      }

      const res = await axios.get(url, {
        headers: getAuthHeaders(getState()),
      });

      if (res.status === 201) {
        dispatch(loadProfileSuccess(res.data.data));
      } else {
        dispatch(loadProfileFailed(res.statusText));
      }
    } catch (err) {
      dispatch(loadProfileFailed(err));
    }
  };
}

// export function updateById(data) {
//   return async function (dispatch, getState) {
//     dispatch(updateOne(data));

//     try {
//       const res = await axios.put(`${window.config.API_URL_USER}profiles/${data.id}`, data, {
//         headers: getAuthHeaders(getState())
//       });

//       if (res.status === 201) {
//         dispatch(updateOneSucess(res.data.data));
//         dispatch(updateNotification('Usuario actualizado correctamente', 'success'));
//       } else {
//         dispatch(updateOneFailed(res, data.id));
//         dispatch(updateNotification('Hubo un error al actualizar el usuario', 'danger'));
//       }
//     } catch (error) {
//       console.log('error:', error);
//       dispatch(updateNotification('Hubo un error al actualizar el usuario', 'danger'));
//       dispatch(updateOneFailed(error, data.id));
//     }
//   };
// }

// export function createProfile(data) {
//   return async function (dispatch, getState) {
//     dispatch(create(data));
//     try {
//       const res = await axios.post(`${window.config.API_URL_USER}profiles`, data, {
//         headers: getAuthHeaders(getState())
//       });

//       if (res.status === 201) {
//         dispatch(createSuccess(res.data.data));
//         /*  dispatch(createSuccessMessage());
//         // history.push('/profiles')
//         dispatch(updateNotification('Usuario creado correctamente', 'success')); */
//       } else if (res.status === 203) {
//         dispatch(createFailed(res.data.message));
//       } else {
//         dispatch(createFailed(res));
//         dispatch(updateNotification('Hubo un error al crear el usuario', 'danger'));
//       }
//     } catch (error) {
//       console.log('error:', error);
//       dispatch(updateNotification('Hubo un error al crear el usuario', 'danger'));
//       dispatch(createFailed(error));
//     }
//   };
// }

// export function destroyProfileById(profileId, MenuId) {
//   return async function (dispatch, getState) {
//     dispatch(deleteProfile(profileId));

//     try {
//       const res = await axios.delete(`${window.config.API_URL_USER}profiles/${profileId}?MenuId=${MenuId}`, {
//         headers: getAuthHeaders(getState())
//       });

//       if (res.status === 201) {
//         dispatch(deleteSuccess({ profileId }));
//         // history.push('/products')
//         dispatch(updateNotification('Perfiles eliminado correctamente', 'success'));
//       } else if (res.status === 203) {
//         dispatch(createFailed(res.data.message));
//       } else {
//         dispatch(deleteFailed(res, profileId));
//         dispatch(updateNotification('Hubo un error al eliminar el usuario', 'danger'));
//       }
//     } catch (error) {
//       console.log('error:', error);
//       dispatch(updateNotification('Hubo un error al eliminar el usuario', 'danger'));
//       dispatch(deleteFailed(error, profileId));
//     }
//   };
// }
